<template>
    <div class="edit-tree-wrapper">
        <RootNode :data="rootData" :editable="editable" :isSelected="isRootSelect" @operatorClick="childOprClick" @selectRoot="selectRootHandler" />
        <div class="tree-list scroll-tracker">
            <div class="tree-list-panel">
                <TreeNode
                    v-for="data in treeDatas"
                    :key="data.id"
                    :data="data"
                    :editable="editable"
                    @selectNode="selectNodeHandler"
                    @expandNode="expandHandler"
                    @operatorClick="childOprClick"
                    @transferEnd="childTransferEnd"
                ></TreeNode>
            </div>
        </div>
    </div>
</template>

<script>
import RootNode from "./RootNode";
import TreeNode from "./TreeNode";
import { updataTreeData } from "@/views/zhiji/js/common/util.js";

/**
 * emit 'nodeSelected'
 */
export default {
    name: "EditTree",
    components: {
        RootNode,
        TreeNode
    },
    props: ["datas", "editable", "current", "maxLevel"],
    computed: {
        rootData() {
            return this.datas;
        },
        isRootSelect() {
            return !this.selectedPath;
        }
    },
    data() {
        return {
            treeDatas: [],
            rootId: this.datas.id,
            selectedPath: ""
        };
    },
    watch: {
        datas() {
            this.treeDatas.splice(0, this.treeDatas.length, ...this.calcTreeDatas());
            this.selectedPath &&
                this.selectNodeHandler({
                    path: this.selectedPath
                });
        },
        current(newVal) {
            this.selectNodeHandler({
                path: newVal || ""
            });
        }
    },
    mounted() {
        this.treeDatas.splice(0, this.treeDatas.length, ...this.calcTreeDatas());
        this.selectedPath = this.current;

        if (this.selectedPath) {
            this.selectNodeHandler({
                path: this.selectedPath
            });
        }
    },
    methods: {
        selectNodeHandler(data) {
            if (this.selectedPath) {
                updataTreeData(this.treeDatas, this.selectedPath.split("/"), treeData => {
                    treeData.isSelected = false;
                });
            }

            this.selectedPath = data.path;

            this.selectedPath &&
                updataTreeData(
                    this.treeDatas,
                    this.selectedPath.split("/"),
                    treeData => {
                        treeData.isSelected = true;
                    },
                    treeData => {
                        treeData.expand = true;
                    }
                );

            this.$emit("nodeSelected", data);
        },
        selectRootHandler() {
            if (this.isRootSelect) {
                return;
            }

            updataTreeData(this.treeDatas, this.selectedPath.split("/"), treeData => {
                treeData.isSelected = false;
            });

            this.selectedPath = "";

            this.$emit("nodeSelected", {
                isRoot: true
            });
        },
        calcTreeDatas() {
            return cvtTreeData(this.datas.children || [], 1, this.maxLevel || 5);
        },
        expandHandler(data) {
            updataTreeData(this.treeDatas, data.path.split("/"), treeData => {
                treeData.expand = !treeData.expand;
            });

            this.$emit("nodeExpanded", data);
        },
        childOprClick(data) {
            if (data.opr === "delete" || data.opr === "add") {
                this.$emit("nodeOperate", data);
            } else if (data.opr === "edit") {
                this.editOperator(data);
            }
        },
        editOperator(data) {
            if (data.newLabel) {
                data.isChanged && this.$emit("nodeOperate", data);
                this.updateEditState(data, false);
            } else {
                this.updateEditState(data, true);
            }
        },
        updateEditState(data, state) {
            updataTreeData(this.treeDatas, data.path.split("/"), treeData => {
                treeData.editing = state;
            });
        },
        childTransferEnd(data) {
            data.opr = "transfer";
            this.$emit("nodeOperate", data);
        }
    }
};

function cvtTreeData(datas, curLevel, maxLevel) {
    if (!datas.length) {
        return [];
    }

    if (curLevel > maxLevel) {
        throw new Error("tree level too large current:" + curLevel);
    }

    return datas.map(function(data, idx) {
        return {
            label: data.label,
            id: data.id,
            smallLabel: data.smallLabel,
            editFlags: data.editFlags,
            children: data.children ? cvtTreeData(data.children, curLevel + 1, maxLevel) : [],
            // 内部使用数据
            level: curLevel,
            isSelected: false,
            expand: data.expand || false,
            isLeaf: curLevel === maxLevel,
            isFirstNode: curLevel == 1 && idx === 0,
            editing: false
        };
    });
}
</script>

<style lang="scss" scoped>
.edit-tree-wrapper {
    height: 100%;
    display: flex;
    flex-direction: column;

    .tree-list {
        overflow-x: hidden;
        overflow-y: auto;
        flex-shrink: 1;
        flex-grow: 1;
    }

    .tree-list-panel {
        padding-top: 1px;
        margin-top: -1px;
        position: relative;
    }
}
</style>
